// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.r-file-thumbnail {
  display: flex;
  flex-direction: column;
  height: 248px;
  width: 185px;
}

  .r-file-thumbnail__dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .r-file-thumbnail__dialog-image {
      max-width: 100%;
      max-height: 100%;
    }

  .r-file-thumbnail__image {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 145px;
    width: 185px;
    cursor: pointer;
    min-height: 0%;
  }

  .r-file-thumbnail__image--error {
      color: red;
    }

  .r-file-thumbnail__image--disabled {
      cursor: default;
    }

  .r-file-thumbnail__image-icon {
      height: 36px;
    }

  .r-file-thumbnail__footer {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    /* align-items: center; */
    margin-top: 9px;
  }

  .r-file-thumbnail__footer-info {
      display: flex;
      flex-direction: column;
    }

  .r-file-thumbnail__footer-info-name {
        text-transform: capitalize;
        color: var(--color-blue-6);
        cursor: pointer;
      }

  .r-file-thumbnail__footer-info-name--disabled {
          color: var(--color-grayscale-5);
          cursor: default;
        }

  .r-file-thumbnail__footer-actions {
      display: flex;
      margin-top: 2px;
    }

  .r-file-thumbnail__footer-action-icon {
      display: flex;
      margin-right: 12px;
      height: 18px;
      width: 18px;
      color: var(--color-blue-6);
      cursor: pointer;
    }

  .r-file-thumbnail__footer-action-icon--disabled {
        color: var(--color-grayscale-5);
        fill: var(--color-grayscale-5);
        cursor: default;
      }

  .r-file-thumbnail__footer-action-icon--active {
        color: var(--color-green-8);
        fill: var(--color-green-8);
        cursor: default;
      }

  .r-file-thumbnail__footer-extended-actions {
      margin-top: 6px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      height: 30px;
      width: 100%;
    }

  .r-file-thumbnail__footer-extended-actions-confirmation-button {
        width: 48%;
      }
`, "",{"version":3,"sources":["webpack://./app/components/FileThumbnail/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,YAAY;AAoGd;;EAlGE;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,YAAY;EAMd;;EAJE;MACE,eAAe;MACf,gBAAgB;IAClB;;EAGF;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,YAAY;IACZ,eAAe;IACf,cAAc;EAahB;;EAXE;MACE,UAAU;IACZ;;EAEA;MACE,eAAe;IACjB;;EAEA;MACE,YAAY;IACd;;EAGF;IACE,aAAa;IACb,sBAAsB;IACtB,8BAA8B;;IAE9B,yBAAyB;IACzB,eAAe;EAwDjB;;EAtDE;MACE,aAAa;MACb,sBAAsB;IAYxB;;EAVE;QACE,0BAA0B;QAC1B,0BAA0B;QAC1B,eAAe;MAMjB;;EAJE;UACE,+BAA+B;UAC/B,eAAe;QACjB;;EAIJ;MACE,aAAa;MACb,eAAe;IACjB;;EAEA;MACE,aAAa;MACb,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,0BAA0B;MAC1B,eAAe;IAajB;;EAXE;QACE,+BAA+B;QAC/B,8BAA8B;QAC9B,eAAe;MACjB;;EAEA;QACE,2BAA2B;QAC3B,0BAA0B;QAC1B,eAAe;MACjB;;EAGF;MACE,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,8BAA8B;MAC9B,YAAY;MACZ,WAAW;IAKb;;EAHE;QACE,UAAU;MACZ","sourcesContent":[".r-file-thumbnail {\n  display: flex;\n  flex-direction: column;\n  height: 248px;\n  width: 185px;\n\n  &__dialog {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    height: 100%;\n\n    &-image {\n      max-width: 100%;\n      max-height: 100%;\n    }\n  }\n\n  &__image {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 145px;\n    width: 185px;\n    cursor: pointer;\n    min-height: 0%;\n\n    &--error {\n      color: red;\n    }\n\n    &--disabled {\n      cursor: default;\n    }\n\n    &-icon {\n      height: 36px;\n    }\n  }\n\n  &__footer {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n\n    /* align-items: center; */\n    margin-top: 9px;\n\n    &-info {\n      display: flex;\n      flex-direction: column;\n\n      &-name {\n        text-transform: capitalize;\n        color: var(--color-blue-6);\n        cursor: pointer;\n\n        &--disabled {\n          color: var(--color-grayscale-5);\n          cursor: default;\n        }\n      }\n    }\n\n    &-actions {\n      display: flex;\n      margin-top: 2px;\n    }\n\n    &-action-icon {\n      display: flex;\n      margin-right: 12px;\n      height: 18px;\n      width: 18px;\n      color: var(--color-blue-6);\n      cursor: pointer;\n\n      &--disabled {\n        color: var(--color-grayscale-5);\n        fill: var(--color-grayscale-5);\n        cursor: default;\n      }\n\n      &--active {\n        color: var(--color-green-8);\n        fill: var(--color-green-8);\n        cursor: default;\n      }\n    }\n\n    &-extended-actions {\n      margin-top: 6px;\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      height: 30px;\n      width: 100%;\n\n      &-confirmation-button {\n        width: 48%;\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
